import React, { useState } from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { Icon, Popover } from '@fiverr-private/fit';
import { s_question_circle } from '@fiverr-private/icons';
import { triggerMixPanelEvent, Events } from '../../../lib/mixpanelEvents';
import { loyaltyPopoverOpenParams } from '../utils';

import './style.scss';

// Note: This component will be extracted into Orca.
const PopoverContent = ({ sellerName }) => (
    <div className="user-page-loyalty-education-popover">
        <div className="education-icon-arrow"></div>
        <div className="popover-content">
            <h5 className={classnames('popover-content-title', 'tbody-3')}>
                <I18n k="user_page_perseus.loyalty_seller.education_icon.header" params={{ sellerName }} parseMarkup/>
            </h5>
            <p className="popover-content-items">
                <I18n k="user_page_perseus.loyalty_seller.education_icon.description" params={{ sellerName }} parseMarkup/>
            </p>
        </div>
    </div>
);

const EducationIcon = ({ sellerId, sellerName }) => {
    const [hovered, setHovered] = useState(false);

    const onOpen = () => {
        if (!hovered) {
            triggerMixPanelEvent(
                Events.GeneralEvents.MP_VIEWED_LOYALTY_BANNER_TOOLTIP,
                {},
                [],
                loyaltyPopoverOpenParams({ sellerId, sellerName })
            );
            setHovered(true);
        }
    };

    return (
        <Popover boxClassName="user-page-loyalty-education-icon-box"
            containerClassName="user-page-loyalty-education-icon-box-container override-default-container"
            boxContentClassName="user-page-loyalty-education-icon-box-content"
            trigger={Popover.TRIGGERS.HOVER}
            position={Popover.POSITIONS.RIGHT}
            content={<PopoverContent sellerName={sellerName}/>}
            onOpen={onOpen}>
            <Icon className="education-icon">{s_question_circle}</Icon>
        </Popover>
    );
};

export default EducationIcon;
